let lenis = null;

export const setLenis = (instance) => {
    lenis = instance;
};

export const scrollToSection = (target) => {
    if (lenis) {
        lenis.scrollTo(target, { offset: -72, duration: 1.4 });
    } else {
        document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
    }
};

export const scrollToTop = () => {
    if (lenis) {
        lenis.scrollTo(0, { duration: 1.2 });
    } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }
};
